import axios from 'axios';
import { Vue } from 'vue-property-decorator';
import { APIGetRequest, APIPostRequest, ScanningQueryStringParameters } from '../../types';

const apiKey = process.env.VUE_APP_API_KEY || '';

export const logError = async (err: any) => {
  await (Vue as any).rollbar.error(err);
};

export const logDebug = (message: any) => {
  (Vue as any).rollbar.debug(message);
};

export const validateHexColor = (rawHexColor: string): boolean => {
  return /^([0-9A-F]{3}){1,2}$/i.test(rawHexColor);
};

export const parseQueryParameters = (rawQueryParameters: any): ScanningQueryStringParameters => {
  const queryParameters: ScanningQueryStringParameters = {
    apiKey: rawQueryParameters.apiKey,
    customerId: parseInt(rawQueryParameters.customerId, 10),
    externalUserId: rawQueryParameters.externalUserId || null,
    locationId: rawQueryParameters.locationId ? parseInt(rawQueryParameters.locationId, 10) : null,
    securityScanningCode: rawQueryParameters.securityScanningCode || null,
    lang: rawQueryParameters.lang || 'en',
    cssURL: rawQueryParameters.cssURL || null,
    primaryColor:
      rawQueryParameters.primaryColor && validateHexColor(rawQueryParameters.primaryColor) ? `#${rawQueryParameters.primaryColor}` : '#00B5EF',
    primaryFontColor:
      rawQueryParameters.primaryFontColor && validateHexColor(rawQueryParameters.primaryFontColor)
        ? `#${rawQueryParameters.primaryFontColor}`
        : '#00B5EF',
    primaryButtonFontColor:
      rawQueryParameters.primaryButtonFontColor && validateHexColor(rawQueryParameters.primaryButtonFontColor)
        ? `#${rawQueryParameters.primaryButtonFontColor}`
        : '#FFF',
    secondColor:
      rawQueryParameters.secondColor && validateHexColor(rawQueryParameters.secondColor) ? `#${rawQueryParameters.secondColor}` : '#5CD895',
    secondFontColor:
      rawQueryParameters.secondFontColor && validateHexColor(rawQueryParameters.secondFontColor)
        ? `#${rawQueryParameters.secondFontColor}`
        : '#5CD895',
    secondButtonFontColor:
      rawQueryParameters.secondButtonFontColor && validateHexColor(rawQueryParameters.secondButtonFontColor)
        ? `#${rawQueryParameters.secondButtonFontColor}`
        : '#FFF',
    headerBackgroundColor:
      rawQueryParameters.headerBackgroundColor && validateHexColor(rawQueryParameters.headerBackgroundColor)
        ? `#${rawQueryParameters.headerBackgroundColor}`
        : '#1E1B1D',
    approveColor:
      rawQueryParameters.approveColor && validateHexColor(rawQueryParameters.approveColor) ? `#${rawQueryParameters.approveColor}` : '#238823',
    denyColor: rawQueryParameters.denyColor && validateHexColor(rawQueryParameters.denyColor) ? `#${rawQueryParameters.denyColor}` : '#D2222D',
  };

  return queryParameters;
};

export const apiGetRequest = async (options: APIGetRequest): Promise<any> => {
  try {
    const headers = {
      'x-api-key': apiKey,
      'content-api-key': options.apiKey,
    };

    const apiReturn = await axios.get(options.apiURL, { headers });

    if (apiReturn.data && apiReturn.data.success && apiReturn.data.data) {
      return apiReturn.data.data;
    } else {
      return null;
    }
  } catch (e) {
    console.log(e);

    const statusCode = e && e.response && e.response.status ? e.response.status : null;

    if (statusCode === 500) {
      await logError(e);
    }

    return null;
  }
};

export const apiPostRequest = async (options: APIPostRequest): Promise<any> => {
  try {
    const headers = {
      'x-api-key': apiKey,
      'content-api-key': options.apiKey,
    };

    const apiReturn = await axios.post(options.apiURL, options.postBody, {
      headers,
    });

    return apiReturn.data;
  } catch (e) {
    console.log(e);

    if (e && e.response && e.response.status === 500) {
      await logError(e);
    }

    return e.response;
  }
};
